// 本地存储功能
export const localSet = (name, value) => localStorage.setItem(name,value)
export const sessionSet = (name, value) => sessionStorage.setItem(name,value)

export const localGet = name => localStorage.getItem(name)
export const sessionGet = name => sessionStorage.getItem(name)

export const localDel = name => localStorage.removeItem(name)
export const sessionDel = name => sessionStorage.removeItem(name)